"use client";

import { useEffect, useState, useCallback } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/lib/auth-context";

export default function UserMenu() {
  const { user, logout } = useAuth();
  const router = useRouter();
  const [open, setOpen] = useState(false);

  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!open) return;
    const id = requestAnimationFrame(() => {
      window.addEventListener("click", close);
    });
    return () => { cancelAnimationFrame(id); window.removeEventListener("click", close); };
  }, [open, close]);

  if (!user) return null;

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    router.push("/");
  };

  return (
    <div className="relative">
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
        className="text-xs text-muted hover:text-foreground transition-colors select-none"
      >
        Logged in as: <span className="text-foreground font-medium">{user}</span>
      </button>
      {open && (
        <div
          className="dropdown-panel absolute right-0 top-full mt-1"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={handleLogout}
            className="dropdown-item"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
